import React from "react";
import {
    FaTrophy,
    FaAward,
    FaGraduationCap,
    FaCalendarCheck,
    FaExternalLinkAlt,
    FaPaperPlane,
} from "react-icons/fa";
import styles from "./AwardPage.module.css";

const AwardPage = () => {
    const deadline = "December 31, 2026";
    const nominationUrl = "https://vacuumelectronics.org";

    const awards = [
        {
            id: "pierce-award",
            badge: "EXCELLENCE AWARD",
            title: "John R. Pierce Award for Excellence in Vacuum Electronics (2027)",
            icon: <FaTrophy />,
            description:
                "Recognizes outstanding contributions and sustained leadership in the field of vacuum electronics.",
        },
        {
            id: "young-scientist",
            badge: "EARLY CAREER",
            title: "Vacuum Electronics Young Scientist Award (2027)",
            icon: <FaAward />,
            description:
                "Honors exceptional achievements and innovative research by young researchers early in their careers.",
        },
    ];

    return (
        <div className={styles.pageContainer}>
            <div className={styles.contentWrapper}>
                {/* Header Section */}
                <header className={styles.header}>
                    <span className={styles.topBadge}>HONORS & RECOGNITION</span>
                    <h1 className={styles.title}>Call for Award Nominations</h1>
                    <p className={styles.subtitle}>
                        Nominations are solicited for prestigious IEEE EDS Vacuum Electronics Technical Committee awards.
                    </p>
                </header>

                {/* Major Awards Grid */}
                <div className={styles.awardsGrid}>
                    {awards.map((award) => (
                        <div key={award.id} className={styles.awardCard}>
                            <div className={styles.cardHeader}>
                                <div className={styles.iconWrapper}>{award.icon}</div>
                                <span className={styles.cardBadge}>{award.badge}</span>
                            </div>
                            <h2 className={styles.awardTitle}>{award.title}</h2>
                            <p className={styles.awardDescription}>{award.description}</p>
                        </div>
                    ))}
                </div>

                {/* Deadline & Nomination Info Card */}
                <div className={styles.infoBox}>
                    <div className={styles.deadlineRow}>
                        <div className={styles.deadlineMeta}>
                            <FaCalendarCheck className={styles.deadlineIcon} />
                            <div>
                                <span className={styles.deadlineLabel}>NOMINATION DEADLINE</span>
                                <strong className={styles.deadlineDate}>{deadline}</strong>
                            </div>
                        </div>
                        <a
                            href={nominationUrl}
                            target="_blank"
                            rel="noopener noreferrer"
                            className={styles.nominateBtn}
                        >
                            Submit Nomination <FaExternalLinkAlt className={styles.btnIcon} />
                        </a>
                    </div>
                    <p className={styles.infoText}>
                        Any member of the vacuum electronics community may submit a nomination for either award as described at the official website of the <strong>Vacuum Electronics Technical Committee of the IEEE Electron Devices Society</strong>.
                    </p>
                </div>

                {/* Student Paper Award Feature Box */}
                <div className={styles.studentFeatureCard}>
                    <div className={styles.studentHeader}>
                        <div className={styles.studentIconWrapper}>
                            <FaGraduationCap />
                        </div>
                        <div>
                            <span className={styles.studentBadge}>STUDENT PRIZE</span>
                            <h2 className={styles.studentTitle}>Best Student Paper Award</h2>
                        </div>
                    </div>
                    <p className={styles.studentDescription}>
                        A prize for the best student paper will be presented during the conference.
                    </p>
                    <div className={styles.eligibilityCallout}>
                        <FaPaperPlane className={styles.eligibilityIcon} />
                        <p className={styles.eligibilityText}>
                            <strong>Eligibility Requirement:</strong> The first author must be a full-time student, and the submission must be identified/marked as a <em>Student Paper</em> during abstract submission.
                        </p>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AwardPage;